import React, { useEffect, useState } from 'react';
import PageWrapper from '../wrappers/PageWrapper';
import tarrifService from '../../services/tarrif.service';
import TarrifBox from '../Global/TarrifBox';
import CircularProgress from '@mui/material/CircularProgress';

const Shop = () => {
  const [tarrifs, setTarrifs] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    tarrifService.getTariffs().then((r) => {
      console.log(r.results);
      if (Array.isArray(r.results)) {
        setIsLoading(false);
        setTarrifs([r.results, r.results, r.results]);
      }
    });
  }, []);

  return (
    <PageWrapper>
      <h2 className='main-title-shop'>Zacznij komfortową wysyłkę wiadomości SMS</h2>
      <div className='shop-page-wrapper'>
        <div className='pricing-options'>
          <div className='list-wrapper price-list'>
            <div className='list-title pricing'></div>
            <ul className='offer-list offer-options'>
              <div>
                <li>
                  <p className='key'>value</p>
                  <p className='value'>Pakiet wiadomości</p>
                </li>
              </div>
              <div>
                <li>
                  <p className='key'>value</p>
                  <p className='value'>Maksymalna liczba urządzeń</p>
                </li>
              </div>
              <div>
                <li>
                  <p className='key'>value</p>
                  <p className='value'>Wysyłka masowa</p>
                </li>
              </div>
              <div>
                <li>
                  <p className='key'>value</p>
                  <p className='value'>Odbieranie wiadomości</p>
                </li>
              </div>
              <div>
                <li>
                  <p className='key'>value</p>
                  <p className='value'>Historia wiadomości</p>
                </li>
              </div>
              <div>
                <li>
                  <p className='key'>value</p>
                  <p className='value'>Planowanie wysyłki</p>
                </li>
              </div>
              <div>
                <li>
                  <p className='key'>value</p>
                  <p className='value'>Obsługa plików CSV</p>
                </li>
              </div>
            </ul>
          </div>
          {!isLoading ? (
            tarrifs.map((tarrif, index) => {
              return (
                <TarrifBox
                  key={tarrif.id || index}
                  isPromote={index == 1}
                  tarrif={tarrif}
                  avaibleSelect
                />
              );
            })
          ) : (
            <CircularProgress />
          )}
        </div>
      </div>
    </PageWrapper>
  );
};

export default Shop;
